module.exports = "/images/road-works@3x.png?a8dc75842f326206b410a1c3f751f8db";